import { render, staticRenderFns } from "./gallery-index.vue?vue&type=template&id=59c8979d&scoped=true&"
import script from "./gallery-index.vue?vue&type=script&lang=js&"
export * from "./gallery-index.vue?vue&type=script&lang=js&"
import style0 from "./gallery-index.vue?vue&type=style&index=0&id=59c8979d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8979d",
  null
  
)

export default component.exports